import React from 'react';
import SEOHead from '../components/SEOHead';

const PrivacyPolicy = () => {
  return (
    <>
      <SEOHead 
        title="Privacy Policy - Saner Consulting"
        description="Privacy Policy for Saner Consulting. Learn how we collect, use, and protect your personal information when you visit our website or use our consulting services."
        keywords="privacy policy, data protection, GDPR, personal information, consulting"
      />

      <div className="page-container">
        {/* Hero Section */}
        <section className="section section-dark">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <h1 className="hero-title">Privacy Policy</h1>
                <p className="hero-subtitle">
                  Your privacy matters to us. This policy explains how we collect, use, and protect your personal information.
                </p>
                <p className="text-muted">
                  <strong>Last updated:</strong> {new Date().toLocaleDateString('en-GB')}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Privacy Policy Content */}
        <section className="section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="legal-content legal-content-single-column">

                  <h2>1. Who We Are</h2>
                  <p>Saner Consulting Limited is a business transformation consultancy. We are committed to protecting your privacy and being transparent about how we handle your personal information.</p>
                  <ul>
                    <li><strong>Company:</strong> Saner Consulting Limited</li>
                    <li><strong>Registration:</strong> England Number 10471658</li>
                    <li><strong>Contact:</strong> contact@sanerconsulting.co.uk</li>
                  </ul>

                  <h2>2. What Information We Collect</h2>
                  <p>We only collect information you voluntarily provide through our contact form:</p>
                  <ul>
                    <li>Your name and email address (required)</li>
                    <li>Company name (optional)</li>
                    <li>Phone number (optional)</li>
                    <li>Service interest and message</li>
                  </ul>
                  
                  <p><strong>We do not track visitors or collect any analytics data.</strong> We do not use tracking cookies, analytics tools, or any other monitoring technologies.</p>

                  <h2>3. How We Use Your Information</h2>
                  <p>We use your contact form information solely to:</p>
                  <ul>
                    <li>Respond to your inquiry</li>
                    <li>Provide information about our consulting services</li>
                    <li>Arrange consultation meetings if requested</li>
                  </ul>
                  
                  <p>We will not send you marketing emails unless you specifically request information about our services.</p>

                  <h2>4. Where Your Information Goes</h2>
                  <p>Contact form submissions are:</p>
                  <ul>
                    <li>Sent directly to our business email</li>
                    <li>Stored securely on our email servers</li>
                    <li>Never shared with third parties</li>
                    <li>Never sold or used for marketing by others</li>
                  </ul>

                  <h2>5. How Long We Keep Information</h2>
                  <ul>
                    <li><strong>Contact inquiries:</strong> Deleted after 2 years unless you become a client</li>
                    <li><strong>Client information:</strong> Kept for 6 years after project completion for business records</li>
                  </ul>

                  <h2>6. Your Rights</h2>
                  <p>You can contact us anytime to:</p>
                  <ul>
                    <li>Ask what information we have about you</li>
                    <li>Correct any wrong information</li>
                    <li>Delete your information</li>
                    <li>Stop us processing your information</li>
                  </ul>

                  <h2>7. Cookies</h2>
                  <p>We only use essential cookies necessary for the website to work properly, including remembering your cookie preferences. See our <a href="/cookie-policy">Cookie Policy</a> for details.</p>

                  <h2>8. Contact Us</h2>
                  <p>Questions about privacy? Email us:</p>
                  <div className="contact-info mt-4 p-4 bg-light rounded">
                    <p><strong>Email:</strong> contact@sanerconsulting.co.uk</p>
                    <p><strong>Subject:</strong> Privacy Question</p>
                  </div>
                  
                  <p>If you're not satisfied with our response, you can contact the <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer">Information Commissioner's Office</a>.</p>

                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy;